export const FetchCareersQuery = `
query FetchCareers ($workspaceId: Int){
    CourseTrail{
      all(orderBy: POSITION_ASC, workspaceId: $workspaceId) {
        items {
          id
          name
          isSelected
          relatedMedia {
            render
          }
        }
      }
    }
  }
`;

export const FetchMyCareersQuery = `
query FetchUserCareers($userId: Int!, $workspaceId: Int){
    CourseTrail{
      all(page:1, perPage: 200, userId: $userId, orderBy: POSITION_ASC, workspaceId: $workspaceId) {
        items {
          id
          name
          isSelected
          progress(uid: $userId)
          lastWatchedCourse(uid: $userId){
            position
          }
          relatedMedia {
            render
          }
        }
      }
    }
  }
`;